var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "index-bg" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "index-content" }, [
        _c("div", { staticClass: "index-fun-body" }, [
          _c(
            "div",
            { staticClass: "carousel" },
            _vm._l(_vm.images, function(image, index) {
              return _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: index == _vm.currentIndex,
                    expression: "index == currentIndex"
                  }
                ],
                key: index,
                attrs: { src: image }
              })
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fun-dots" },
            _vm._l(_vm.images, function(image, index) {
              return _c("div", {
                key: index,
                staticClass: "dot",
                class: { "dot-seletced": index == _vm.currentIndex }
              })
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "login-body" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "input-body" }, [
            _c("div", { staticClass: "input-photo" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.mobile,
                    expression: "formData.mobile"
                  }
                ],
                attrs: { type: "number", placeholder: "手机号" },
                domProps: { value: _vm.formData.mobile },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "mobile", $event.target.value)
                    },
                    _vm.limitMobile
                  ]
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-sms" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.sms_code,
                    expression: "formData.sms_code"
                  }
                ],
                attrs: { type: "number", placeholder: "短信验证码" },
                domProps: { value: _vm.formData.sms_code },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.formData, "sms_code", $event.target.value)
                    },
                    _vm.limitSmsCode
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sms-btn",
                  class: { "sms-btn-click": _vm.isCountingDown },
                  on: {
                    click: function($event) {
                      return _vm.getSmsCode()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.isCountingDown
                          ? _vm.countdown + "s 后重新获取"
                          : "获取短信验证码"
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "login-btn", on: { click: _vm.submitLogic } },
            [_vm._v("登录")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "privacy" }, [
            _c(
              "div",
              { staticClass: "privacy-check", on: { click: _vm.rePrivacy } },
              [
                _vm.rePrivacySelected
                  ? _c("img", {
                      attrs: { src: require("@/assets/ic_selected_y.png") }
                    })
                  : _c("img", {
                      attrs: { src: require("@/assets/ic_selected_n.png") }
                    })
              ]
            ),
            _vm._v("\n          登录表示您已阅读并同意\n          "),
            _c(
              "label",
              {
                on: {
                  click: function($event) {
                    return _vm.clickTerm(1)
                  }
                }
              },
              [_vm._v("服条协议")]
            ),
            _vm._v(" "),
            _c("span", [_vm._v("和")]),
            _vm._v(" "),
            _c(
              "label",
              {
                on: {
                  click: function($event) {
                    return _vm.clickTerm(2)
                  }
                }
              },
              [_vm._v("隐私政策")]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _vm._m(6)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-bar" }, [
      _c("div", { staticClass: "logo" }, [
        _c("img", { attrs: { src: require("../../assets/logo.png"), alt: "" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "logo-name" }, [
        _c("img", {
          attrs: { src: require("../../assets/logo_name.png"), alt: "" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-title" }, [
      _vm._v("\n          请使用"),
      _c("label", [_vm._v("手机号码")]),
      _vm._v("登录\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-bg" }, [
      _c("img", {
        attrs: { src: require("../../assets/bg_banner.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-bg" }, [
      _c("img", {
        attrs: { src: require("../../assets/bg_banner1.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-bg" }, [
      _c("img", {
        attrs: { src: require("../../assets/bg_banner2.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner-bg" }, [
      _c("img", {
        attrs: { src: require("../../assets/bg_banner3.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _vm._v("\n    Copyright © 2024 深圳市寻讯科技有限公司 版权所有 "),
      _c(
        "a",
        {
          attrs: {
            href: "https://beian.miit.gov.cn/#/Integrated/index",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v(" 粤ICP备2024291999号")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56292d8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56292d8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/content/login/login_page.vue
// module id = null
// module chunks = 